// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import './VoteCollection.scss';
import Button from '../../../Util/Button/Button';
import { observable } from 'mobx';
import Request from '../../../../api/Request';
import DeleteAllComments from '../../../Dialogs/DeleteAllComments/DeleteAllComments';

@inject('userStore', 'componentStore', 'modalStore', 'messageStore')
@observer class VoteCollection extends Component<any, any> {

	@observable secondButtonLoading: boolean = false;
	@observable firstButtonLoading: boolean = false;

	constructor(props: any) {
		super(props);

		this.vote = this.vote.bind(this);
		this.askRemoveAction = this.askRemoveAction.bind(this);
		this.askChangeAction = this.askChangeAction.bind(this);
	}

	componentDidMount() {
		if(this.props.userStore.user) {
			Request.get('/questions/' + this.props.question.id + '/votes?limit=1&user=' + this.props.userStore.user.id, {}).then((response) => {
				if (!response.status && response.length > 0) {
					this.props.componentStore.chosenOptionId = response[0].question_option.id;;
				}else {
					this.props.componentStore.chosenOptionId = undefined;
				}
			})
		} else {
			this.props.componentStore.chosenOptionId = undefined;
		}
	}

	toggleLoading(id: number) {
		if(id === this.props.question.question_options[0].id) {
			this.firstButtonLoading = !this.firstButtonLoading;
		} else {
			this.secondButtonLoading = !this.secondButtonLoading;
		}
	}

	vote(e: any, id: number) {
		if(!this.props.componentStore.chosenOptionId && this.props.userStore.user) {
			this.toggleLoading(id);
			Request.post('/questions/' + this.props.question.id + '/vote/' + id, {}, {}).then((response) => {
				if(!response.status) {
					this.props.componentStore.chosenOptionId = id;
				}
				this.toggleLoading(id);
			})
		} else {
			if(this.props.userStore.user) {
				if(this.props.componentStore.chosenOptionId === id) {
					this.props.modalStore.createModal('Continue?', <DeleteAllComments action={() => this.askRemoveAction(id)}/>)
				} else if (this.props.componentStore.chosenOptionId && this.props.componentStore.chosenOptionId !== id) {
					this.props.modalStore.createModal('Continue?', <DeleteAllComments action={() => this.askChangeAction(id)}/>)
				}
			} else {
				this.props.messageStore.setMessage('error', 'you have to be logged in');
			}
		}
	}

	askRemoveAction(id: number) {
		this.props.modalStore.removeModal();
		this.toggleLoading(id);
		this.removeVote(id).then((response: any) => {
			if(response) {
				this.props.componentStore.justRemovedComments = id;
				this.props.componentStore.chosenOptionId = undefined;
			}
			this.toggleLoading(id);
		})
	}

	askChangeAction(id: number) {
		this.props.modalStore.removeModal();
		this.toggleLoading(id);
		this.changeVote(this.props.componentStore.chosenOptionId, id).then((response: any) => {
			if(response) {
				this.props.componentStore.justRemovedComments = this.props.componentStore.chosenOptionId;
				this.props.componentStore.chosenOptionId = id;
			}
			this.toggleLoading(id);
		})
	}

	async removeVote(id: number): Promise<boolean> {
		const response = await Request.delete('/questions/' + this.props.question.id + '/vote/' + id, {}, {});
		if(!response) {
			return true;
		} 
		return false;
	}

	async changeVote(oldId: number, newId: number): Promise<boolean> {
		if (await this.removeVote(oldId)) {
			const response = await Request.post('/questions/' + this.props.question.id + '/vote/' + newId, {}, {});
			if(!response.status) {
				return true;
			} 
		}

		return false;
	}

	render() {
		return (
			<div className="vote-collection">
				<div className="option option-1">
					<div className="given-vote given-vote-1">{this.props.question.question_options[0].votes}</div>
					<Button 
						className={this.props.componentStore.chosenOptionId === this.props.question.question_options[0].id ? 'voted' : ''} 
						text={this.props.question.question_options[0].name} 
						onClick={(e: any) => this.vote(e, this.props.question.question_options[0].id)}
						loading={this.firstButtonLoading}/>
				</div>
				<div className="option option-2">
					<div className="given-vote given-vote-2">{this.props.question.question_options[1].votes}</div>
					<Button 
						className={this.props.componentStore.chosenOptionId === this.props.question.question_options[1].id ? 'voted' : ''} 
						text={this.props.question.question_options[1].name} 
						onClick={(e: any) => this.vote(e, this.props.question.question_options[1].id)}
						loading={this.secondButtonLoading}/>
				</div>
			</div>
		)
	}
}

export default VoteCollection;

